import React from 'react';
import './ServiceCard.css';

function ServiceCard({ title, description, icon }) {
  return (
    <div className="service-card">
      <div className="service-card-icon-container">
        <img src={icon} alt={`${title} icon`} className="service-card-icon" />
      </div>
      <div className="service-card-content">
        <h2 className="service-card-title">{title}</h2>
        <p className="service-card-description">{description}</p>
      </div>
    </div>
  );
}

export default ServiceCard;
